import { createContext, useEffect, useMemo, useState } from "react";
import { useConfig } from "../config/configContext";
import { AudioScheduler } from "./audioScheduler";

export const AudioSchedulerContext = createContext<[AudioScheduler, string | null]>([new AudioScheduler([".mp3"], () => { }), null]);

export const AudioSchedulerProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
    const config = useConfig();
    const [playingAudio, setPlayingAudio] = useState<string | null>(null);
    const audioScheduler = useMemo(() => new AudioScheduler(config.audioFormats, setPlayingAudio), [config.audioFormats]);
    //stop all audio upon unmount and for the old audioScheduler, in case the audioScheduler is ever recreated (e.g. when the audioFormats change)
    useEffect(() => {
        return audioScheduler.stopAllIncludingSilence;
    }, [audioScheduler]);
    return (
        <AudioSchedulerContext.Provider value={[
            audioScheduler,
            playingAudio //&& !playingAudio.includes("silence") ? playingAudio : null
        ]}>
            {children}
        </AudioSchedulerContext.Provider>
    );
};